export const FLASH_OPEN = 'FLASH_OPEN';
export const GENERIC_ERROR = 'GENERIC_ERROR';

export default function flash(text, type) {
  return type !== 'error' ? { type: FLASH_OPEN, text } : { type: GENERIC_ERROR, message: text };
}
